import { render, staticRenderFns } from "./DesktopDownloadDocumentsButton.vue?vue&type=template&id=09845148"
import script from "./DesktopDownloadDocumentsButton.vue?vue&type=script&lang=js"
export * from "./DesktopDownloadDocumentsButton.vue?vue&type=script&lang=js"
import style0 from "./DesktopDownloadDocumentsButton.vue?vue&type=style&index=0&id=09845148&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports